<template>
  <v-badge
    color="red darken-2"
    :content="getUnreadNotificationsCount"
    :value="getUnreadNotificationsCount > 0"
    bottom
    overlap
    offset-x="10"
  >
    <w-icon color="white">
      $wNotification
    </w-icon>
  </v-badge>
</template>

<script>
import { mapGetters } from 'vuex';
import notificationService from '@/modules/notifications/services/notification-service';

export default {
  name: 'WorkNotificationTrackerIcon',
  computed: {
    ...mapGetters('badgeCounter', ['getUnreadNotificationsCount']),
  },
  async mounted() {
    notificationService.updateUnreadNotificationsCount();
  },
};
</script>
